import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { Sidebar } from './Sidebar';

export function AppShell() {
  const [menuOpen, setMenuOpen] = useState(false);
  return (
    // The shell is exactly one viewport tall; only the content column scrolls, so the sidebar never grows with the page.
    <div className="flex h-dvh overflow-hidden bg-bg">
      <Sidebar open={menuOpen} onClose={() => setMenuOpen(false)} />
      <div className="flex min-w-0 flex-1 flex-col overflow-y-auto">
        <Header onMenu={() => setMenuOpen(true)} />
        <main className="flex flex-1 flex-col gap-5 p-4 lg:p-7">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
